import { createMessageName } from '@formkit/validation';
import { sentence, date, order, list } from '../formatters.mjs';

// packages/i18n/src/locales/nb.ts
var add = "Legg til";
var remove = "Fjern";
var removeAll = "Fjern alle";
var incomplete = "Beklager, noen felter er ikke fylt ut korrekt.";
var submit = "Send inn";
var noFiles = "Ingen fil valgt";
var moveUp = "Flytt opp";
var moveDown = "Flytt ned";
var isLoading = "Laster...";
var loadMore = "Last mer";
var next = "Neste";
var prev = "Forrige";
var addAllValues = "Legg til alle verdier";
var addSelectedValues = "Legg til valgte verdier";
var removeAllValues = "Fjern alle verdier";
var removeSelectedValues = "Fjern valgte verdier";
var chooseDate = "Velg dato";
var changeDate = "Endre dato";
var accepted = function({
  name
}) {
  return `Vennligst aksepter ${name}.`;
};
var date_after = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} må være senere enn ${date(args[0])}.`;
  }
  return `${sentence(name)} må være i fremtiden.`;
};
var alpha = function({
  name
}) {
  return `${sentence(name)} kan bare inneholde alfabetiske tegn.`;
};
var alphanumeric = function({
  name
}) {
  return `${sentence(name)} kan bare inneholde bokstaver og tall.`;
};
var alpha_spaces = function({
  name
}) {
  return `${sentence(name)} kan bare inneholde bokstaver og mellomrom.`;
};
var contains_alpha = function({
  name
}) {
  return `${sentence(name)} must contain alphabetical characters.`;
};
var contains_alphanumeric = function({
  name
}) {
  return `${sentence(name)} must contain letters and numbers.`;
};
var contains_alpha_spaces = function({
  name
}) {
  return `${sentence(name)} must contain letters and spaces.`;
};
var contains_symbol = function({
  name
}) {
  return `${sentence(name)} must contain symbol.`;
};
var contains_uppercase = function({
  name
}) {
  return `${sentence(name)} must contain uppercase.`;
};
var contains_lowercase = function({
  name
}) {
  return `${sentence(name)} must contain lowercase.`;
};
var contains_numeric = function({
  name
}) {
  return `${sentence(name)} must contain number.`;
};
var symbol = function({
  name
}) {
  return `${sentence(name)} can only contain symbol.`;
};
var uppercase = function({
  name
}) {
  return `${sentence(name)} can only contain uppercase.`;
};
var lowercase = function({
  name
}) {
  return `${sentence(name)} can only contain lowercase.`;
};
var date_before = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} må være tidligere enn ${date(args[0])}.`;
  }
  return `${sentence(name)} må være i fortiden.`;
};
var between = function({
  name,
  args
}) {
  if (isNaN(args[0]) || isNaN(args[1])) {
    return `Dette feltet er feilkonfigurert og kan ikke innsendes.`;
  }
  const [a, b] = order(args[0], args[1]);
  return `${sentence(name)} må være mellom ${a} og ${b}.`;
};
var confirm = function({
  name
}) {
  return `${sentence(name)} stemmer ikke overens.`;
};
var date_format = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} er ikke en gyldig dato, vennligst bruk formatet ${args[0]}`;
  }
  return "Dette feltet er feilkonfigurert og kan ikke innsendes.";
};
var date_between = function({
  name,
  args
}) {
  return `${sentence(name)} må være mellom ${date(args[0])} og ${date(args[1])}`;
};
var email = "Vennligst oppgi en gyldig epostadresse.";
var ends_with = function({
  name,
  args
}) {
  return `${sentence(name)} slutter ikke med ${list(args)}.`;
};
var is = function({
  name
}) {
  return `${sentence(name)} er ikke en tillatt verdi.`;
};
var length = function({
  name,
  args: [first = 0, second = Infinity]
}) {
  const min2 = Number(first) <= Number(second) ? first : second;
  const max2 = Number(second) >= Number(first) ? second : first;
  if (min2 == 1 && max2 === Infinity) {
    return `${sentence(name)} må ha minst ett tegn.`;
  }
  if (min2 == 0 && max2) {
    return `${sentence(name)} må ha mindre enn eller nøyaktig ${max2} tegn.`;
  }
  if (min2 === max2) {
    return `${sentence(name)} skal være ${max2} tegn langt.`;
  }
  if (min2 && max2 === Infinity) {
    return `${sentence(name)} må ha mer enn eller nøyaktig ${min2} tegn.`;
  }
  return `${sentence(name)} må ha mellom ${min2} og ${max2} tegn.`;
};
var matches = function({
  name
}) {
  return `${sentence(name)} er ikke en tillatt verdi.`;
};
var max = function({
  name,
  node: {
    value
  },
  args
}) {
  if (Array.isArray(value)) {
    return `Kan ikke ha mer enn ${args[0]} ${name}.`;
  }
  return `${sentence(name)} må være mindre enn eller nøyaktig ${args[0]}.`;
};
var mime = function({
  name,
  args
}) {
  if (!args[0]) {
    return "Ingen tillatte filformater.";
  }
  return `${sentence(name)} må være av typen: ${args[0]}`;
};
var min = function({
  name,
  node: {
    value
  },
  args
}) {
  if (Array.isArray(value)) {
    return `Kan ikke ha mindre enn ${args[0]} ${name}.`;
  }
  return `${sentence(name)} må være minst ${args[0]}.`;
};
var not = function({
  name,
  node: {
    value
  }
}) {
  return `“${value}” er ikke en tillatt ${name}.`;
};
var number = function({
  name
}) {
  return `${sentence(name)} må være et tall.`;
};
var require_one = function({
  name,
  node,
  args: inputNames
}) {
  const labels = inputNames.map((name2) => {
    const dependentNode = node.at(name2);
    if (dependentNode) {
      return createMessageName(dependentNode);
    }
    return false;
  }).filter((name2) => !!name2);
  labels.unshift(name);
  return `${labels.join(" eller ")} er nødvendig.`;
};
var required = function({
  name
}) {
  return `${sentence(name)} er påkrevd.`;
};
var starts_with = function({
  name,
  args
}) {
  return `${sentence(name)} starter ikke med ${list(args)}.`;
};
var url = function() {
  return `Vennligst inkluder en gyldig url.`;
};
var invalidDate = "Den valgte datoen er ugyldig.";
var ui = {
  add,
  remove,
  removeAll,
  incomplete,
  submit,
  noFiles,
  moveUp,
  moveDown,
  isLoading,
  loadMore,
  next,
  prev,
  addAllValues,
  addSelectedValues,
  removeAllValues,
  removeSelectedValues,
  chooseDate,
  changeDate
};
var validation = {
  accepted,
  date_after,
  alpha,
  alphanumeric,
  alpha_spaces,
  contains_alpha,
  contains_alphanumeric,
  contains_alpha_spaces,
  contains_symbol,
  contains_uppercase,
  contains_lowercase,
  contains_numeric,
  symbol,
  uppercase,
  lowercase,
  date_before,
  between,
  confirm,
  date_format,
  date_between,
  email,
  ends_with,
  is,
  length,
  matches,
  max,
  mime,
  min,
  not,
  number,
  require_one,
  required,
  starts_with,
  url,
  invalidDate
};
var nb_default = {
  ui,
  validation
};

export { accepted, add, addAllValues, addSelectedValues, alpha, alpha_spaces, alphanumeric, between, changeDate, chooseDate, confirm, contains_alpha, contains_alpha_spaces, contains_alphanumeric, contains_lowercase, contains_numeric, contains_symbol, contains_uppercase, date_after, date_before, date_between, date_format, nb_default as default, email, ends_with, incomplete, invalidDate, is, isLoading, length, loadMore, lowercase, matches, max, mime, min, moveDown, moveUp, next, noFiles, not, number, prev, remove, removeAll, removeAllValues, removeSelectedValues, require_one, required, starts_with, submit, symbol, uppercase, url };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=nb.mjs.map